import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import duration from 'dayjs/plugin/duration'

import studentsIcon from '../../assets/images/students-icon.png'

dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(timezone)
const date = new Date()
const tzOffset = date.getTimezoneOffset()

export const CheckInCard = ({
  cardData,
  onSubmit,
  updating,
  cardInd,
  isManage,
  setOpenManage,
  setManageInd,
}) => {
  const calculateHours = (outT, inT) => {
    const outTime = dayjs(outT)
    const inTime = dayjs(inT)
    const diff = dayjs.duration(outTime.diff(inTime))
    const diffFormatted = diff.format('HH:mm')

    return isNaN(parseFloat(diffFormatted)) ? '00:00' : diffFormatted
  }
  return (
    <div className="trtui-row">
      <div className="trtui-col-12">
        <div className="trtui-card mb-0" style={{ marginBottom: '1rem' }}>
          <div className="trtui-card-body" style={{ paddingBottom: 0, paddingTop: 0 }}>
            <div className="trtui-d-sm-flex trtui-align-items-center">
              <div className="trtui-d-flex">
                <div className="trtui-avatar-sm trtui-rounded">
                  <img
                    src={studentsIcon}
                    alt="studentIcon"
                    className="trtui-member-img trtui-img-fluid trtui-d-block trtui-rounded"
                  />
                </div>
                <div
                  className="trtui-d-flex trtui-gap-4 trtui-d-block trtui-d-md-none trtui-mt-0 trtui-text-muted trtui-mx-auto"
                  style={{ right: '1rem', position: 'absolute' }}
                >
                  <div>
                    <span className="trtui-badge trtui-bg-success-subtle trtui-text-success">
                      {dayjs(cardData.checkInDateTime).format('HH:mm A')}
                    </span>
                  </div>
                  <div className="trtui-ml-5">
                    <span className="trtui-badge trtui-bg-danger-subtle trtui-text-danger">
                      {dayjs(cardData.checkOutDateTime).format('HH:mm A')}
                    </span>
                  </div>
                </div>
              </div>
              <div className="trtui-ms-lg-3 trtui-my-3 trtui-my-lg-0">
                <a href="#!">
                  <h5 className="trtui-fs-16 trtui-mb-2">
                    {cardData.Application?.UserChild?.userChildName}
                  </h5>
                </a>
                <p className="trtui-text-muted trtui-mb-0">
                  <span
                    className="trtui-cursor-pointer"
                    style={{ fontWeight: 'bold' }}
                    onClick={() => {
                      if (isManage) {
                        setOpenManage(true)
                        setManageInd(cardInd)
                      }
                    }}
                    title={isManage ? 'Edit Attendance' : 'Activities'}
                  >
                    {cardData.userAttendance?.userFullName}
                  </span>
                </p>
              </div>
              <div className="trtui-d-flex trtui-gap-4 trtui-d-none trtui-d-md-block trtui-mt-0 trtui-text-muted trtui-mx-auto">
                <div className="trtui-row">
                  <div className="trtui-col-6">
                    <span className="trtui-badge trtui-bg-success-subtle trtui-text-success">
                      Check-In:{' '}
                      {dayjs(cardData.checkInDateTime).utcOffset(tzOffset, true).format('hh:mm A')}
                    </span>
                  </div>
                  {cardData.checkOutConfirmedDateTime !== null && (
                    <div className="trtui-col-6">
                      <span className="trtui-badge trtui-bg-danger-subtle trtui-text-danger">
                        Check-Out:{' '}
                        {cardData.checkOutConfirmedDateTime !== null
                          ? dayjs(cardData.checkOutConfirmedDateTime)
                              .utcOffset(tzOffset, true)
                              .format('hh:mm A')
                          : ' NA '}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                {cardData.checkInConfirmedDateTime === null && (
                  <button
                    type="button"
                    disabled={updating}
                    className="trtui-btn trtui-btn-soft-success"
                    onClick={() => onSubmit(cardData, 1)}
                  >
                    {updating ? (
                      <span className="trtui-d-flex trtui-align-items-center">
                        <span className="trtui-flex-grow-1 trtui-me-2">Confirming...</span>
                        <span className="trtui-spinner-border trtui-flex-shrink-0" role="status">
                          <span className="trtui-visually-hidden">Confirming...</span>
                        </span>
                      </span>
                    ) : (
                      'Check-In Confirm'
                    )}
                  </button>
                )}
                {cardData.checkInConfirmedDateTime !== null &&
                  cardData.checkOutDateTime !== null &&
                  cardData.checkOutConfirmedDateTime === null && (
                    <button
                      className="trtui-btn trtui-btn-soft-danger"
                      type="button"
                      disabled={updating}
                      onClick={() => onSubmit(cardData, 3)}
                    >
                      {updating ? (
                        <span className="trtui-d-flex trtui-align-items-center">
                          <span className="trtui-flex-grow-1 trtui-me-2">Confirming...</span>
                          <span className="trtui-spinner-border trtui-flex-shrink-0" role="status">
                            <span className="trtui-visually-hidden">Confirming...</span>
                          </span>
                        </span>
                      ) : (
                        'Check-Out Confirm'
                      )}
                    </button>
                  )}
                {cardData.checkOutConfirmedDateTime !== null && (
                  <>Hours: {calculateHours(cardData.checkOutDateTime, cardData.checkInDateTime)}</>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CheckInCard.propTypes = {
  cardData: PropTypes.object,
  onSubmit: PropTypes.func,
  updating: PropTypes.bool,
  openActivity: PropTypes.func,
  cardInd: PropTypes.number,
  setActivityAttenInd: PropTypes.func,
  isManage: PropTypes.bool,
  setOpenManage: PropTypes.func,
  setManageInd: PropTypes.func,
}
